import { useContext } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { Breadcrumb as AntdBreadcrumb } from 'antd';
import {
  BreadcrumbItemType,
  BreadcrumbSeparatorType,
} from 'antd/es/breadcrumb/Breadcrumb';

import { InfoContext } from '../../../../contexts';
import { MenuOption } from '../../../../interfaces';
import { getMenuIcon } from '../SideMenu/utils/icons';

import './index.css';

const searchPath = (menu: any, pathBuscado: string) => {
  for (let item of menu) {
    if (item.path === pathBuscado) return item;

    if (item.subMenues && item.subMenues.length > 0) {
      const found: any = searchPath(item.subMenues, pathBuscado);

      if (found) return found;
    }
  }

  return null;
};

const _renderItems = (menu: Array<MenuOption>): any => {
  const { pathname } = useLocation();
  const pathnames = pathname.split('/').filter((item) => item);
  const firstPath = searchPath(menu, `/${pathnames[0]}`);
  const { title } = useContext(InfoContext);

  let items: Array<Partial<BreadcrumbItemType & BreadcrumbSeparatorType>> = [];

  const renderImageLink = (path: string) => (
    <Link to={path}>
      { getMenuIcon( path ) }
    </Link>
  );

  const renderTextLink = (description: string) => (
    <span className='breadcrum-links'>{description}</span>
  );

  items.push({
    key: 0,
    title: renderImageLink( firstPath?.path ),
  });
  if(firstPath?.path) {
    items.push({
      key: 1,
      title: <Link to={firstPath?.path ? firstPath?.path : '/home'}>{firstPath?.descripcion ? firstPath?.descripcion : 'Home'}</Link>,
    });
  }
  items.push({
    key: 2,
    title: renderTextLink(title),
  });

  return items;
};

export const Breadcrumb = ({ menus }: any) => (
  <AntdBreadcrumb style={{ margin: '16px 0' }} items={_renderItems(menus)} />
);
